import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "twitch-small",
  "use": "twitch-small-usage",
  "viewBox": "0 0 172 172",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 172 172\" fill-rule=\"evenodd\" id=\"twitch-small\">\n  <path fill=\"none\" d=\"M0 0h172v172H0z\" />\n  <path d=\"M89,77l-9,23v94h32v17h18l17-17h26l35-35V77H89Zm107,76-20,20H144l-17,17V173H100V89h96v64Zm-20-41v35H164V112h12Zm-32,0v35H132V112h12Z\" transform=\"translate(-57 -56)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol